import muty_logo from "./assets/images/common/muty_logo.png";

export const PROJECT_NAME = "Muty";
export const PROJECT_META_NAME = "muty";
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT; //production | development

export const TOKEN_KEY =
  ENVIRONMENT === "development"
    ? `_${PROJECT_META_NAME}_token`
    : `_${PROJECT_META_NAME}_token_dev`;

export const API_ENDPOINT =
  ENVIRONMENT === "production"
    ? process.env.REACT_APP_PROD_API_ENDPOINT
    : process.env.REACT_APP_DEV_API_ENDPOINT;

export const IDLE_TIME_IN_SECONDS = 300;

export const LOGO = muty_logo;
export const SLUG_SPECIAL_CHAR = /[^\w-]/g
